import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoutes';


const SettingsRoute=({component:Component, isVerified, ...args}) => {


    const RenderComponent= isVerified ? 
                            Component : 
                            ({ location }) => ( <Redirect to={{
                                                pathname:'/verification',
                                                state:{ prevUrl: location.pathname }
                                            }} 
                                    /> 
                                );

    return (
        <ProtectedRoute component = { RenderComponent } {...args} />
    )
    

}

const mapStateToProps=( state ) => {
    return {
        isVerified : state.user.isVerified
    }
}


export default connect( mapStateToProps )( SettingsRoute );